import { getIsAIChatbot } from '../../selectors/widgetDataSelectors/getIsAIChatbot';
import { hasPersistedThreads } from '../../threads/selectors/hasPersistedThreads';
import { getIsUngatedForStandaloneRecommendedQuestions } from '../../widget-data/selectors/widgetDataSelectors';
import { fetchStandalonePromptRecommendations } from './fetchStandalonePromptRecommendations';
export const fetchStandaloneAIRecommendations = () => (dispatch, getState) => {
  const state = getState();
  if (getIsAIChatbot(state) && getIsUngatedForStandaloneRecommendedQuestions(state) && !hasPersistedThreads(state)) {
    void dispatch(fetchStandalonePromptRecommendations());
  }
};